<template>
  <q-header elevated class="bg-secondary main-layout-header">
    <q-toolbar style="">
      <div class="branding">
        <a href="https://www.medicalconnections.co.uk/">
          <q-img class="show" src="../assets/logo.svg">
            <div class="text-subtitle1 text-center hide hover-text hide">
              Visit our website
            </div></q-img
          ></a
        >

        <div id="color-picker-container" style="color: white !important">
          <div class="q-pa-md q-gutter-md demo-title">
            <div class="text-h5" style="margin-top: 60px;">
              DICOM Web Viewer Demo
              <q-badge align="middle" color="#fff"> v3.1 </q-badge>
            </div>
          </div>
        </div>

        <div id="toolbar-right-side"></div>
      </div>
    </q-toolbar>
  </q-header>
</template>

<script>
import { ref } from "vue";
import { SessionStorage, setCssVar } from "quasar";

export default {
  name: "Header",
  data() {
    return {
      primaryColor: "#162a4a",
      secondaryColor: "#0a1526",
      highlightColor: "#d39b38",
      textColor: "#e0e0e0",
      colorDialog: false,
      tempPrimaryColor: "#162a4a",
      tempSecondaryColor: "#0a1526",
      tempHighlightColor: "#d39b38",
      tempTextColor: "#e0e0e0",
    };
  },
  watch: {
    primaryColor: function (primaryColor) {
      SessionStorage.set("primaryColor", primaryColor);
      setCssVar("primary", primaryColor);
      setCssVar("dark", this.shadeColor(primaryColor, -25));
      setCssVar("accent", this.shadeColor(primaryColor, 80));
    },
    secondaryColor: function (secondaryColor) {
      SessionStorage.set("secondaryColor", secondaryColor);
      setCssVar("secondary", secondaryColor);
    },
    highlightColor: function (highlightColor) {
      SessionStorage.set("highlightColor", highlightColor);
      setCssVar("info", highlightColor);
    },
    textColor: function (textColor) {
      SessionStorage.set("textColor", textColor);
      setCssVar("positive", textColor);
    },
  },
  created() {
    // Set default color values

    // First check session storage
    if (SessionStorage.getItem("primaryColor"))
      this.primaryColor = SessionStorage.getItem("primaryColor");
    // Overwrite with cookie storage if exists
    if (this.getCookie("primaryColor") != "")
      this.primaryColor = this.getCookie("primaryColor");

    if (SessionStorage.getItem("secondaryColor"))
      this.secondaryColor = SessionStorage.getItem("secondaryColor");
    if (this.getCookie("secondaryColor") != "")
      this.secondaryColor = this.getCookie("secondaryColor");

    if (SessionStorage.getItem("highlightColor"))
      this.highlightColor = SessionStorage.getItem("highlightColor");
    if (this.getCookie("highlightColor") != "")
      this.highlightColor = this.getCookie("highlightColor");

    if (SessionStorage.getItem("textColor"))
      this.textColor = SessionStorage.getItem("textColor");
    if (this.getCookie("textColor") != "")
      this.textColor = this.getCookie("textColor");

    this.resetTempColours();
  },
  methods: {
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    setCookie(cname, cvalue, exMins) {
      var d = new Date();
      d.setTime(d.getTime() + exMins * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    resetColours() {
      var defaultPrimaryColor = "#162a4a";
      var defaultSecondaryColor = "#0a1526";
      var defaultHighlightColor = "#d39b38";
      var defaultTextColor = "#e0e0e0";

      if (this.getCookie("primaryColor"))
        defaultPrimaryColor = this.getCookie("primaryColor");
      if (this.getCookie("secondaryColor"))
        defaultSecondaryColor = this.getCookie("secondaryColor");
      if (this.getCookie("highlightColor"))
        defaultHighlightColor = this.getCookie("highlightColor");
      if (this.getCookie("textColor"))
        defaultTextColor = this.getCookie("textColor");

      this.primaryColor = defaultPrimaryColor;
      this.secondaryColor = defaultSecondaryColor;
      this.highlightColor = defaultHighlightColor;
      this.textColor = defaultTextColor;
    },
    clearCookies() {
      this.setCookie("primaryColor", "", 0);
      this.setCookie("secondaryColor", "", 0);
      this.setCookie("highlightColor", "", 0);
      this.setCookie("textColor", "", 0);

      this.primaryColor = "#162a4a";
      this.secondaryColor = "#0a1526";
      this.highlightColor = "#d39b38";
      this.textColor = "#e0e0e0";

      this.resetTempColours();
    },
    shadeColor(color, percent) {
      var R = parseInt(color.substring(1, 3), 16);
      var G = parseInt(color.substring(3, 5), 16);
      var B = parseInt(color.substring(5, 7), 16);

      R = parseInt((R * (100 + percent)) / 100);
      G = parseInt((G * (100 + percent)) / 100);
      B = parseInt((B * (100 + percent)) / 100);

      R = R < 255 ? R : 255;
      G = G < 255 ? G : 255;
      B = B < 255 ? B : 255;

      var RR =
        R.toString(16).length == 1 ? "0" + R.toString(16) : R.toString(16);
      var GG =
        G.toString(16).length == 1 ? "0" + G.toString(16) : G.toString(16);
      var BB =
        B.toString(16).length == 1 ? "0" + B.toString(16) : B.toString(16);

      return "#" + RR + GG + BB;
    },
    saveColours() {
      this.primaryColor = this.tempPrimaryColor;
      this.secondaryColor = this.tempSecondaryColor;
      this.highlightColor = this.tempHighlightColor;
      this.textColor = this.tempTextColor;
    },
    saveDefaultColours() {
      this.saveColours();

      this.setCookie("primaryColor", this.primaryColor);
      this.setCookie("secondaryColor", this.secondaryColor);
      this.setCookie("highlightColor", this.highlightColor);
      this.setCookie("textColor", this.textColor);
    },
    resetTempColours() {
      this.tempPrimaryColor = this.primaryColor;
      this.tempSecondaryColor = this.secondaryColor;
      this.tempHighlightColor = this.highlightColor;
      this.tempTextColor = this.textColor;
    },
  },
};
</script>

<style>
.q-toolbar {
  height: 100%;
  background: var(--q-secondary);
  margin-left: 0px;
}

.q-toolbar .q-badge {
  background-color: var(--q-accent);
}

.branding {
  grid-column: col-start / span 2;
  height: 100%;
}

.branding a {
  height: fit-content;
}

.branding .q-img {
  width: 200px;
  height: 200px;
  bottom: 25px;
  float: left;
  margin-left: 23px;
}

.branding .q-img__image {
  object-fit: contain !important;
}

#toolbar-right-side {
  float: right;
  color: #e0e0e0;
}

.q-header {
  min-height: 50px;
}

.main-layout-header {
  min-height: 150px !important;
}

.hover-text {
  top: 70px;
  cursor: pointer;
}

.show:hover .hide {
  visibility: visible;
  opacity: 1;
  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s; /* Firefox < 16 */
  -ms-animation: fadein 1s; /* Internet Explorer */
  -o-animation: fadein 1s; /* Opera < 12.1 */
  animation: fadein 1s;
}

.hide {
  visibility: hidden;
}

[dir] .q-field__native {
  color: white;
}

[dir] .q-field--with-bottom {
  padding-bottom: 10px !important;
  height: 50px;
}

.color-picker-text-container {
  width: 500px;
  height: fit-content;
  margin-left: auto;
  margin-top: 15px;
  text-align: right;
  color: var(--q-positive);
}

#color-picker-container button {
  margin-right: 10px !important;
}

#color-picker-container .reset-button {
  margin-right: 30px !important;
}

#color-picker-container .color-picker-text {
  margin-right: 10px !important;
}

.demo-title {
  margin-left: auto;
  text-align: right;
}

.color-picker-card {
  overflow-x: hidden !important;
  min-width: max-content;
  padding: 10px;
}

.color-preview-container {
  height: 100%;
  text-align: -webkit-center;
  text-align: -moz-center;
}

.color-preview-header {
  height: 10%;
}

.color-preview-viewer {
  margin-top: 50px;
  background: black;
  height: 30%;
  outline-width: 2px;
  outline-style: solid;
  border-radius: 5px;
  width: 80%;
}

.color-preview-text {
  font-size: 3em;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>